let cachedIsIOS = null;

// iOS (including iPadOS) detection. iPadOS 13+ masquerades as desktop Safari
// ("MacIntel" platform, no iPad in the UA); real Macs report maxTouchPoints
// 0/1 while iPads report > 1 - that's the discriminator. Lazily computed and
// cached: nothing runs at import time, and tests can reset by re-mocking
// navigator before first call.
export function isIOSDevice() {
  if (cachedIsIOS === null) {
    const ua = navigator.userAgent || '';
    cachedIsIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }
  return cachedIsIOS;
}
